/**
 * Tous les javascripts sont inclus dans ce fichier, cela inclus
 * les plugins et autres scripts.
 */

require('@webcomponents/webcomponentsjs');
require('./polyfill');

//window.$ = window.jQuery = require('../../../assets/global/plugins/jquery.min');
require('../../../assets/global/plugins/bootstrap/js/bootstrap.min');

// Plugins
require('./plugins');
window.ImageEditor = require('./modules/imageeditor/imageeditor').ImageEditor

require('../../../assets/global/scripts/app_new');
require('../../../assets/layouts/layout4/scripts/layout.min');
require('../../../assets/layouts/layout4/scripts/demo.min');

require('../../../assets/global/scripts/custom');